// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';

const ContainerTitle = styled.div`
  padding-top: 2rem !important;
  padding-bottom: 0.25rem !important;
  color: #fff;
`;

const StyledDiv = styled.div`
  justify-content: center !important;
  display: flex !important;
  align-items: center !important;
`;

const Title = styled.h4`
  text-transform: uppercase;
  padding: 0;
  margin: 0;
  font-weight: bold;
`;

const StyledLine = styled.div`
  border-top: 1px solid #444;
  margin: 10px 0;
`;

const PageContainerTitleComponent = ({title}) => {
  return (
    <ContainerTitle>
      <StyledDiv>
        <Title>{title}</Title>
      </StyledDiv>
      <StyledLine/>
    </ContainerTitle>
  );
};

export default PageContainerTitleComponent;
